import React from "react";
import {
  FiUsers,
  FiGrid,
  FiBriefcase,
  FiSettings,
  FiTrendingUp,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const corePlatforms = [
  {
    title: "EventShield",
    desc: "AI-Powered SIEM + SOC platform for modern security operations.",
    icon: <FiGrid />,
  },
  {
    title: "MCT Network Monitoring System",
    desc: "AI-powered network monitoring & observability platform.",
    icon: <FiSettings />,
  },
  {
    title: "MCTZyntra",
    desc: "Zero trust network access platform for secure enterprise connectivity.",
    icon: <FiUsers />,
  },
  {
    title: "AI-powered MCTEMS",
    desc: "Enterprise management platform integrating NMS + ITSM.",
    icon: <FiBriefcase />,
  },
];

const partnerModels = [
  {
    title: "Channel Partners",
    desc: "Grow with MapleCloud’s enterprise software portfolio across security, operations, and SaaS platforms.",
  },
  {
    title: "Technology Partners",
    desc: "Integrate complementary technologies and strengthen customer outcomes.",
  },
  {
    title: "Implementation Partners",
    desc: "Support deployment, onboarding, and operational adoption.",
  },
  {
    title: "Strategic Alliances",
    desc: "Build long-term value through enterprise collaboration and market expansion.",
  },
];

function Partners() {
    const navigate = useNavigate();
  return (
    <div className="home-about pt-10 text-white min-h-screen">
      
      {/* Hero Section */}
      <section className="px-6 md:px-16 py-20">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          
          {/* Left Side */}
          <div>
            <p className="text-cyan-400 uppercase tracking-widest text-sm mb-4">
              Partners & Ecosystem
            </p>

            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              A product-led ecosystem for enterprise growth.
            </h1>

            <p className="text-gray-300 mt-6 text-md leading-relaxed">
              MapleCloud works with partners, customers, and technology
              ecosystems to deliver enterprise software platforms for
              AI-SecOps, monitoring, access, enterprise management,
              and SaaS operations.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <button className="bg-cyan-500 hover:bg-cyan-600 px-6 py-3 rounded-full font-semibold transition">
                Become a Partner
              </button>

              <button onClick={() => navigate('/contactpage')} className="border border-gray-500 px-6 py-3 rounded-full hover:border-cyan-400 transition">
                Contact Sales
              </button>
            </div>
          </div>

          {/* Right Side Card */}
          <div className="bg-gradient-to-br from-[#08162e] to-[#123a74] p-10 rounded-2xl border border-cyan-500/20 shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">
              Collaborate with MapleCloud
            </h2>

            <p className="text-gray-300 leading-relaxed">
              Build with a focused enterprise software portfolio across
              security, operations, and business workflows.
            </p>
          </div>
        </div>
      </section>

      {/* Core Platforms */}
      <section className="px-6 md:px-16 pb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">
          Core Platforms
        </h2>

        <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
          {corePlatforms.map((item, index) => (
            <div
              key={index}
              className="bg-[#071428] p-6 rounded-2xl border border-cyan-500/10 hover:border-cyan-400 hover:shadow-[0_0_20px_rgba(0,255,255,0.15)] transition"
            >
              <div className="w-12 h-12 rounded-lg bg-cyan-500/20 flex items-center justify-center text-cyan-400 text-xl mb-4">
                {item.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3">
                {item.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Partner Models */}
      <section className="px-6 md:px-16 pb-20">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">
          Partner Models
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {partnerModels.map((item, index) => (
            <div
              key={index}
              className="bg-[#071428] p-8 rounded-2xl border border-cyan-500/10 hover:border-cyan-400 hover:shadow-[0_0_20px_rgba(0,255,255,0.12)] transition"
            >
              <h3 className="text-2xl font-semibold mb-4">
                {item.title}
              </h3>

              <p className="text-gray-400 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Partners;